import { AbstractControlDirective, AbstractControl } from '@angular/forms';

const genKey = 'genericError';
const errorMessages = {
    required: () => 'Câmp obligatoriu',
    minlength: (params) =>
      'Numărul minim de caractere este ' + params.requiredLength,
    maxlength: (params) =>
      'Numărul maxim de caractere este ' + params.requiredLength,
    email: (params) => 'Adresă de email invalidă.',
    equalTo: (params) => 'Cuvintele nu se potrivesc.',
    pattern: (pattern) => handlePattern(pattern),
    genericError: (params) => 'Parola nu se potrivește.',
    lowercaseCharacterRule: (params) =>
      'Numărul minim de minuscule este ' + params.required,
    digitCharacterRule: (params) =>
      'Numărul minim de cifre este ' + params.required,
    uppercaseCharacterRule: (params) =>
      'Numărul minim de majuscule este  ' + params.required,
    specialCharacterRule: (params) =>
      'Numărul minim de caractere speciale este ' + params.required,
  };


export const shouldShowErrors = (
  control: AbstractControlDirective | AbstractControl
): boolean => (
      control &&
      control.errors &&
      (control.dirty || control.touched)
    );

export const listOfErrors = (
  control: AbstractControlDirective | AbstractControl
): any => {
  if (shouldShowErrors(control)) {
     return Object.keys(control.errors).map((field) =>
    getMessage(field, control.errors[field])
  );
  }

};

  const getMessage = (type: string, params: any) => errorMessages[type]
      ? errorMessages[type](params)
      : errorMessages[genKey](params);


 const handlePattern = (pattern: any) => {
    const rP =
      pattern && pattern.hasOwnProperty('requiredPattern')
        ? RegExp(pattern.requiredPattern).source.toString()
        : null;

    const strongPass = RegExp(
      '^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})'
    ).source.toString();

    switch (rP) {
      case strongPass:
        return 'Accepted values: 0-9';
      default:
        return 'Field value error';
    }
  };
